import React from "react";

const Contact = () => {
    return (
        <div>
            <h1>Fish Life Contact</h1>
        </div>
    );
};

export default Contact;